import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import "./registrationfrom.css";
// import FormInputs from "./FormInputs";
// import DropDown from "./Dropdown";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import EditIcon from "../../Assets/Images/EployeeRegistration/edit_icon.png";
import { fetchGradeData } from "../../Redux/EmployeeRegistration/gradeSlice";

function GuardianInfo({ setGaurdianInfo }) {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [values, setValues] = useState({
    fathers_name: "",
    fathers_occupation: "",
    fathers_designation: "",
    fathers_annual_income: "",
    fathers_email_id: "",
    fathers_mob_no: "",
    mothers_name: "",
    mothers_occupation: "",
    mothers_designation: "",
    mothers_annual_income: "",
    mothers_email_id: "",
    mothers_mob_no: "",
    guardian_name: "",
    guardian_mob_no: "",
    guardian_relation: null,
    comments_: "",
  });

  useEffect(() => {
    setGaurdianInfo(values);
  }, [values, setGaurdianInfo]);

  useEffect(() => {
    dispatch(fetchGradeData());
  }, [dispatch]);

  // const onChange = (e) => {
  //   const { name, value } = e.target;
  //   setValues({ ...values, [name]: value });
  //   setGaurdianInfo((prevInfo) => ({
  //     ...prevInfo,
  //     [name]: value,
  //   }));
  // };

  // Remove the double state update in onChange
  const onChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="personal-info">
      <div className="personal-header">
        <div className="header">
          <h2>GUARDIAN INFORMATION</h2>
          <img src={EditIcon} alt="icon" />
        </div>
        <div className="accordion-btn" onClick={toggleAccordion}>
          {isOpen ? (
            <div className="minus"></div>
          ) : (
            <div className="plus">+</div>
          )}
        </div>
      </div>
      {isOpen && (
        <div className="accordion-content">
          <div className="grid-container">
            <div className="grid-item">
              <FormInputs
                label="Father’s Name"
                type="text"
                name="fathers_name"
                value={values.fathers_name}
                onChange={onChange}
                // maxlength="150"
                maxlength={200}
                pattern="[A-Za-z ]{1,150}"
              />
            </div>
            <div className="grid-item">
              <FormInputs
                label="Occupation"
                type="text"
                name="fathers_occupation"
                value={values.fathers_occupation}
                onChange={onChange}
                // maxlength="50"
                maxlength={15}
                pattern="[A-Za-z ]{1,50}"
              />
            </div>
            <div className="grid-item">
              <FormInputs
                label="Designation"
                type="text"
                name="fathers_designation"
                value={values.fathers_designation}
                onChange={onChange}
                // maxlength="50"
                maxlength={15}
                pattern="[A-Za-z ]{1,50}"
              />
            </div>
            <div className="grid-item">
              <div className="selecte-dropdown-items">
                <DropDown
                  label="Annual Income"
                  setSelected={(selectedOption) =>
                    setValues({
                      ...values,
                      fathers_annual_income: selectedOption,
                    })
                  }
                  options={[
                    { label: "0 To Rs 2,00,000", id: "1" },
                    { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
                    { label: "Rs 400000 To Rs 6,00,000", id: "3" },
                    { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
                    { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
                    { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
                    { label: "> Rs 15,00,000", id: "7" },
                    { label: "Not Available", id: "8" },
                  ]}
                />
              </div>
            </div>
            <div className="grid-item">
              <FormInputs
                label="Email ID"
                type="email"
                name="fathers_email_id"
                value={values.fathers_email_id}
                onChange={onChange}
                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
              />
            </div>
            <div className="grid-item">
              <FormInputs
                label="Mobile Number"
                type="text"
                name="fathers_mob_no"
                value={values.fathers_mob_no}
                onChange={onChange}
                pattern="[0-9]{10,11}"
                maxLength={10}
              />
            </div>
            <div className="grid-item" style={{ marginTop: "40px" }}>
              <FormInputs
                label="Mother’s Name"
                type="text"
                name="mothers_name"
                value={values.mothers_name}
                onChange={onChange}
                // maxlength="50"
                maxlength={200}
                pattern="[A-Za-z ]{1,50}"
              />
            </div>
            <div className="grid-item" style={{ marginTop: "40px" }}>
              <FormInputs
                label="Occupation"
                type="text"
                name="mothers_occupation"
                value={values.mothers_occupation}
                onChange={onChange}
                // maxlength="50"
                maxlength={15}
                pattern="[A-Za-z ]{1,50}"
              />
            </div>
            <div className="grid-item" style={{ marginTop: "40px" }}>
              <FormInputs
                label="Designation"
                type="text"
                name="mothers_designation"
                value={values.mothers_designation}
                onChange={onChange}
                // maxlength="50"
                maxlength={15}
                pattern="[A-Za-z ]{1,50}"
              />
            </div>
            <div className="grid-item">
              <div className="selecte-dropdown-items">
                <DropDown
                  label="Annual Income"
                  setSelected={(selectedOption) =>
                    setValues({
                      ...values,
                      mothers_annual_income: selectedOption,
                    })
                  }
                  options={[
                    { label: "0 To Rs 2,00,000", id: "1" },
                    { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
                    { label: "Rs 400000 To Rs 6,00,000", id: "3" },
                    { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
                    { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
                    { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
                    { label: "> Rs 15,00,000", id: "7" },
                    { label: "Not Available", id: "8" },
                  ]}
                />
              </div>
            </div>
            <div className="grid-item">
              <FormInputs
                label="Email ID"
                type="email"
                name="mothers_email_id"
                value={values.mothers_email_id}
                onChange={onChange}
                maxlength={150}
                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
              />
            </div>
            <div className="grid-item">
              <FormInputs
                label="Mobile Number"
                type="text"
                name="mothers_mob_no"
                value={values.mothers_mob_no}
                onChange={onChange}
                pattern="[0-9]{10,11}"
                maxLength={10}
              />
            </div>
            <div className="grid-item">
              <FormInputs
                label="Guardian Name"
                type="text"
                name="guardian_name"
                value={values.guardian_name}
                onChange={onChange}
                // maxlength="50"
                maxlength={200}
                pattern="[A-Za-z, ]{1,50}"
              />
            </div>
            <div className="grid-item">
              <FormInputs
                label="Guardian’s Mobile Number"
                type="text"
                name="guardian_mob_no"
                value={values.guardian_mob_no}
                onChange={onChange}
                pattern="[0-9]{10,11}"
                maxLength={10}
              />
            </div>
            <div className="grid-item">
              <FormInputs
                label="Guardian’s Relation"
                type="text"
                name="guardian_relation"
                value={values.guardian_relation}
                onChange={onChange}
                pattern="[0-9]{0,4}"
                maxLength={4}
              />
            </div>
            <div className="comments">
              <label>Comments</label>
              <textarea
                name="comments_"
                value={values.comments_}
                onChange={onChange}
                placeholder="Write your comment here..."
                maxLength={500}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default GuardianInfo;
